<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>

              <v-flex xs8>
                <v-text-field
                  label="菜单名称"
                  required
                  :rules="rules.normal"
                  v-model="item.name"/>
              </v-flex>

              <v-flex xs2>
                <v-text-field
                  label="图标"
                  v-model="item.icon"/>
              </v-flex>

              <v-flex xs2>
                <v-text-field
                  label="排序"
                  required
                  :rules="rules.rank"
                  v-model="item.rank"/>
              </v-flex>

              <v-flex xs12>
                <v-autocomplete
                  label="上级菜单"
                  item-text="name"
                  item-value="dbid"
                  autocomplete
                  clearable
                  :loading="parentLoading"
                  :items="parentItems"
                  :search-input.sync="parentSearch"
                  v-model="item.parentId"
                  v-on:keyup.enter="onParentSearch"
                  @click:append="onParentSearch"
                  hint="输入关键词检索"
                  persistent-hint
                />
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  label="路由 Path"
                  v-model="item.route"/>
              </v-flex>

              <v-flex xs12>
                <v-autocomplete
                  label="角色"
                  item-text="name"
                  item-value="dbid"
                  clearable
                  multiple
                  :items="roleItems"
                  v-model="item.roleIds"
                  persistent-hint
                  required
                  :rules="rules.required"
                />
                <!--:disabled="!item.parentId || item.parentId.length === 0"-->
              </v-flex>

              <v-flex xs12>
                <v-text-field label="备注" v-model="item.note"/>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSave">保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import mixin from '@/mixin'

  const baseUri = '/api/syst/menu';
  const roleUri = '/api/syst/role';

  export default {
    mixins: [mixin.edit(baseUri)],
    data() {
      return {
        formValid: false,

        item: {},
        freshItem: {
          "parentId": null,
          "name": null,
          "disabled": null,
          "route": null,
          "icon": null,
          "note": null,

          "roleIds": []
        },

        /**
         * 验证规则
         */
        rules: {
          required: [
            v => !!v || '必填项。'
          ],
          normal: [v => (v && v.length <= 50) || '长度必须小于50个字符。'],
          rank: [
            v => !!v || '必填项。',
            v => (v && /^\d+$/i.test(v)) || '只能填正整数。'
          ]
        },

        parentLoading: false,
        parentItems: [],
        parentSearch: '',

        roleLoading: false,
        roleItems: [],
        roleSearch: ''
      }
    },

    created() {
      this.axios
        .get(roleUri, {params: {limit: 65535, disabled: 'F', sort: 'order.asc'}})
        .then(rsp => this.roleItems = rsp.data.items)
    },

    methods: {
      // mixin 加载数据后调用
      afterGetData(data) {
        this.parentItems = data.parent ? [data.parent] : [];

        data.roleIds = data.roles.map(r => r.dbid);
      },

      // 父节点下拉框
      onParentSearch() {
        const vm = this;
        const param = window.xutil.param("name", this.parentSearch);
        param["sort"] = "rank.asc";
        param["root"] = true;

        vm.parentLoading = true;
        this.axios.get(baseUri, {params: param})
          .then(
            rsp => {
              vm.parentLoading = false;
              vm.parentItems = rsp.data.items
            })
      }
    }
  }
</script>
